import StreamingLessonMediaPage from './container'
export default StreamingLessonMediaPage
